import React, {Component} from "react";  import config from 'react-global-configuration';
import {Tab, Tabs} from 'react-bootstrap';
import UploadFiles from 'anycardemi/uploadFiles';
import MyRequests from 'anycardemi/myRequests';
import Reports from 'anycardemi/Reports';
import PendingTasks from 'anycardemi/PendingTasks';
import jwt_decode from "jwt-decode";

class Brefcase extends Component {
    constructor(props){
        super(props);
        this.state = {
            userType:''
        }

    }
    componentDidMount() {
        const token = localStorage.usertoken;
        const decoded = jwt_decode(token);
        this.setState(
            {
                      userType:decoded.userType
                  }
        )
    }
    handleSelectTab(key, e) {
        if(key=='myrequests') {
            this.refs.ChildMyReq.showRequests();
        }
        if(key=='reports') {
            this.refs.ChildMyReports.showReports();
            this.refs.ChildMyReports.get_req_no_lists();
        }
        if(key=='pendingtasks') {
            this.refs.ChildMyPendingTask.showPendingTasks();
        }
    }
    render() {
        return (
            <div className="content">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-12 pt-5">
                            <div className="card">
                                <div className="header">
                                    <h4 className="title">ANY CARD EMI</h4>
                                    <p className="category"></p>
                                </div>
                                <div className="content">
                                    <React.Fragment>
                                        <Tabs defaultActiveKey="uploadfiles" id="query-builder-tab" onSelect={this.handleSelectTab.bind(this)} >
                                            <Tab eventKey="uploadfiles" title="Upload File" >
                                                <UploadFiles/>
                                            </Tab>
                                            <Tab eventKey="myrequests" title="My Requests" >
                                                <MyRequests ref="ChildMyReq"/>
                                            </Tab>
                                            <Tab eventKey="reports" title="Reports"  >
                                                <Reports ref="ChildMyReports" />
                                            </Tab>
                                            <Tab eventKey="pendingtasks" title="Pending Tasks"  >
                                                <PendingTasks ref="ChildMyPendingTask"/>
                                            </Tab>
                                        </Tabs>
                                    </React.Fragment>
                                    <div className="footer">
                                        <div className="stats"><i></i>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default Brefcase;
